import { Layers } from 'lucide-react';

export function CategoryDefinition() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
          A New Category
        </p>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6">
          Procedure Revenue Integrity (PRI)
        </h2>

        <div className="max-w-3xl mx-auto">
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            LINK is not RCM. It is not a billing service.{' '}
            <span className="text-foreground font-semibold">
              We are an enforcement layer.
            </span>{' '}
            We sit between the OR and the claim to ensure 100% alignment between
            Authorization, Documentation, and Confirmation.
          </p>
        </div>

        <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-0">
          {(['Authorization', 'Documentation', 'Confirmation'] as const).map(
            (pillar, i) => (
              <div key={pillar} className="flex items-center gap-4 sm:gap-0">
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 rounded-xl border border-primary/30 bg-primary/10 flex items-center justify-center">
                    <span className="text-lg font-bold text-primary">{pillar[0]}</span>
                  </div>
                  <span className="text-xs font-semibold text-foreground mt-2 tracking-tight">
                    {pillar}
                  </span>
                </div>
                {i < 2 && (
                  <div className="hidden sm:block w-12 md:w-16 h-px bg-border mx-3 md:mx-4" />
                )}
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}
